import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";

/**
 * Shown when the user tries to pay / upgrade online but Razorpay is not wired yet.
 */
export default function PaymentUnavailableDialog({
  open,
  onClose,
  actionLabel = "online payment",
}) {
  return (
    <Dialog open={!!open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Online payments not available yet</DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 1.5 }}>
          {actionLabel.charAt(0).toUpperCase() + actionLabel.slice(1)} is not
          fully integrated right now.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
          Our payment gateway (Razorpay) has not been connected for this
          environment, so checkout cannot be completed in the app.
        </Typography>
        <Box
          sx={{
            background: "#f8fafc",
            border: "1px solid #e2e8f0",
            borderRadius: 1,
            p: 1.5,
          }}
        >
          <Typography variant="body2" sx={{ mb: 0.75 }}>
            What you can do:
          </Typography>
          <Typography variant="body2" component="ul" sx={{ m: 0, pl: 2 }}>
            <li>Contact Zordigo support to upgrade your plan or clear invoices</li>
            <li>Email us from the help menu in the navbar</li>
            <li>
              Visit{" "}
              <a
                href="https://zordigo.com/pricing.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                zordigo.com/pricing
              </a>
            </li>
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Got it</Button>
        <Button
          variant="contained"
          onClick={() => {
            window.open(
              "https://zordigo.com/pricing.html",
              "_blank",
              "noopener,noreferrer",
            );
            onClose?.();
          }}
        >
          Contact / pricing
        </Button>
      </DialogActions>
    </Dialog>
  );
}
